import { Link, useLocation } from 'react-router-dom';

import { Button } from './atoms';

export default function Nav() {
	
	const location = useLocation();
	
	return(
		<nav className="nav-top">
			<Link to="/" className="nav-logo">
				<svg className="logo" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_17_14)">
				<path className="logo-background" d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z" fill="#ED1E79"/>
				<path d="M35.7861 27.1604C35.6293 23.4701 35.3917 12.3873 35.3917 12.3873C35.3727 11.6602 34.6455 11.1683 33.9612 11.4178L26.4095 14.198C26.0269 14.3382 25.7584 14.6875 25.718 15.0939L24.4253 28.6479C24.3754 29.1683 23.6174 29.1683 23.5675 28.6479L22.2748 15.0939C22.2368 14.6875 21.9683 14.3382 21.5834 14.198L14.0317 11.4178C13.3497 11.166 12.6226 11.6602 12.6012 12.3873C12.6012 12.3873 12.3731 23.4701 12.2067 27.1604C12.0642 30.3042 14.0008 38.046 23.9192 38.046C33.8376 38.046 35.9335 30.7343 35.7814 27.1604H35.7861Z" fill="white"/>
				</g>
				<defs>
				<clipPath id="clip0_17_14">
				<rect width="48" height="48" fill="white"/>
				</clipPath>
				</defs>
				</svg>
				<div><span>tunga</span> education</div>
			</Link>
			<div className="nav-links">
				<Link to="/" className={`${location.pathname==="/" ? 'active' : ''}`}>Home</Link>
				{/* <Link to="/products" className={`${location.pathname==="/products" ? 'active' : ''}`}>Products</Link> */}
				<Link to="/about" className={`${location.pathname==="/about" ? 'active' : ''}`}>About us</Link>
			</div>
			<Button to="mailto:hello@tungaeducation.com" role="glow">Get in touch</Button>
		</nav>
	)
	
}